



































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import {
  InsertCommunity,
  UpdateCommunity,
  GetCommunityListForParent
} from "@/api/pdCommunity/index";
@Component
export default class CommunityDetail extends AbpBase {
  @Prop() data: any;
  model: any = {};
  communityList: any = [];
  rules = {
    code: [
      {
        required: true,
        message: "社区编码不能为空",
        trigger: "blur"
      }
    ],
    name: [
      {
        required: true,
        message: "社区名称不能为空",
        trigger: "blur"
      }
    ]
  };

  @Watch("data", { immediate: true, deep: true })
  onDataChanged() {
    if (this.data) {
      this.model = Object.assign({}, this.data);
    }
  }

  async handleNameChanged() {
    let res = await GetCommunityListForParent(this.model.name);
    this.communityList = res.objects;
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
      if (this.model.id == 0) {
        await InsertCommunity(this.model);
      } else {
        await UpdateCommunity(this.model);
      }
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/community/detail.vue